export default function AsyncButton({ busy, busyText = "Working…", children, disabled, ...props }) {
  return (
    <button {...props} disabled={busy || disabled} aria-disabled={busy || disabled} aria-busy={busy || undefined}>
      {busy && <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />}
      {busy ? busyText : children}
    </button>
  );
}
